/* assets/flikety-slider-a11y.js
   Keeps aria-hidden and focusability in sync with visible Flickity cells.
*/
(function () {
  function setFocusability(card, isVisible) {
    var link = card.querySelector('.product-card-link');
    if (link) {
      if (isVisible) link.removeAttribute('tabindex');
      else link.setAttribute('tabindex', '-1');
    }
    var focusables = card.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    focusables.forEach(function (el) {
      if (link && el === link) return;
      var tag = el.tagName.toLowerCase();
      var naturallyFocusable =
        (tag === 'a' && el.hasAttribute('href')) ||
        tag === 'button' || tag === 'input' || tag === 'select' ||
        tag === 'textarea' || (el.hasAttribute('tabindex') && el.tabIndex >= 0);

      if (isVisible) {
        if (el.getAttribute('data-a11y-overridden') === '1') {
          el.removeAttribute('tabindex');
          el.removeAttribute('data-a11y-overridden');
        }
      } else if (naturallyFocusable) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('data-a11y-overridden', '1');
      }
    });
  }

  function isPartiallyVisible(el, containerRect, thresholdRatio) {
    var r = el.getBoundingClientRect();
    var left = Math.max(r.left, containerRect.left);
    var right = Math.min(r.right, containerRect.right);
    var top = Math.max(r.top, containerRect.top);
    var bottom = Math.min(r.bottom, containerRect.bottom);
    var iw = Math.max(0, right - left);
    var ih = Math.max(0, bottom - top);
    var inter = iw * ih;
    var area = r.width * r.height;
    if (!area) return false;
    return inter / area >= thresholdRatio;
  }

  function getFlickityInstance(root) {
    if (root.flickity) return root.flickity;
    if (root._flkty) return root._flkty;
    if (window.jQuery) {
      var data = window.jQuery(root).data && window.jQuery(root).data('flickity');
      if (data) return data;
    }
    return null;
  }

  function updateForSlider(sliderRoot) {
    var viewport = sliderRoot.querySelector('.flickity-viewport');
    if (!viewport) return;
    var cells = sliderRoot.querySelectorAll('.gallery-cell');
    var vRect = viewport.getBoundingClientRect();
    var THRESHOLD = 0.30;

    cells.forEach(function (cell) {
      var visible = isPartiallyVisible(cell, vRect, THRESHOLD);
      cell.setAttribute('aria-hidden', visible ? 'false' : 'true');
      setFocusability(cell, visible);
      // Optionally: cell.toggleAttribute('inert', !visible);
    });
  }

  function installA11ySync(sliderRoot) {
    var flkty = getFlickityInstance(sliderRoot);
    if (!flkty) return;
    function run() { updateForSlider(sliderRoot); }

    flkty.on('ready', run);
    flkty.on('select', run);
    flkty.on('settle', run);
    flkty.on('scroll', run);
    window.addEventListener('resize', run);
    run();
  }

  function initAll() {
    document.querySelectorAll('.products-slider.flickity-enabled').forEach(function (slider) {
      if (slider.__a11ySynced) return;
      if (getFlickityInstance(slider)) {
        installA11ySync(slider);
        slider.__a11ySynced = true;
      }
    });
  }

  window.SliderA11y = window.SliderA11y || {};
  window.SliderA11y.initAll = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
  document.addEventListener('shopify:section:unload', initAll);
})();
